<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>

<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_555_428)">
                            <path
                                d="M24.0149 9.38963C23.7088 8.65691 23.2457 7.99931 22.658 7.46259C22.0419 6.90877 21.3186 6.48573 20.5324 6.21935C19.6597 5.92531 18.7434 5.7799 17.8221 5.78925C16.695 5.77739 15.576 5.97983 14.5254 6.38568C13.5793 6.74544 12.721 7.30144 12.0078 8.01667C11.2946 8.7319 10.7427 9.58996 10.389 10.5338C10.0161 11.516 9.82876 12.5583 9.83645 13.6083C9.82488 14.5956 10.008 15.5756 10.3755 16.4929C10.7282 17.3556 11.273 18.1276 11.9689 18.7509C12.3474 19.0893 12.7649 19.382 13.2125 19.6229L16.0141 18.7963C15.9786 18.7896 15.9431 18.7812 15.9093 18.7745C15.0676 18.6061 14.2712 18.2625 13.5724 17.7664C12.9484 17.3128 12.4464 16.7133 12.1108 16.0208C11.7687 15.2999 11.5959 14.5111 11.6056 13.7141C11.6048 13.0822 11.6849 12.4527 11.8439 11.8408C11.992 11.2553 12.2242 10.6939 12.5333 10.1742C12.8593 9.61814 13.2895 9.12938 13.8006 8.73437C14.3311 8.3342 14.929 8.03099 15.5663 7.8389C16.2879 7.62307 17.0382 7.51716 17.7917 7.52475C18.5129 7.51445 19.2308 7.62404 19.9156 7.84901C20.4903 8.03801 21.0208 8.34028 21.4753 8.73777C21.8877 9.10843 22.2146 9.56352 22.4333 10.0717C22.6735 10.6412 22.7861 11.2558 22.7633 11.8729C22.7405 12.49 22.583 13.0948 22.3015 13.6452C22.0353 14.18 21.6641 14.6564 21.21 15.0464C20.7115 15.4546 20.4175 15.5403 20.2586 15.5403C20.2429 15.5404 20.2273 15.5368 20.2132 15.5298C20.1991 15.5228 20.1869 15.5126 20.1775 15.5C20.1447 15.4541 20.1291 15.3982 20.1336 15.3421C20.1494 15.1239 20.1839 14.9076 20.2367 14.6952L21.1407 10.4531C21.199 10.1784 21.1546 9.89207 21.0159 9.64758C20.8772 9.40309 20.6536 9.21723 20.3871 9.12477C20.1205 9.0323 19.8292 9.03958 19.5676 9.14523C19.3061 9.25088 19.0922 9.44766 18.966 9.69877C18.7249 9.42339 18.4238 9.20638 18.0856 9.0643C17.7474 8.92221 17.381 8.8588 17.0144 8.8789C16.1981 8.87275 15.4043 9.14492 14.7654 9.65005C14.1053 10.1649 13.585 10.8353 13.2514 11.6006C12.9065 12.3571 12.7262 13.1775 12.7225 14.0081C12.7003 14.7163 12.8826 15.4159 13.248 16.0242C13.574 16.5513 14.0589 16.9628 14.6336 17.2003C15.1928 17.4299 15.8082 17.4884 16.401 17.3683C16.9235 17.2639 17.4101 17.0272 17.8136 16.6811C17.9057 16.8907 18.0602 17.0672 18.2563 17.1868C18.5784 17.3575 18.9411 17.4382 19.3056 17.4203C20.0208 17.4242 20.7273 17.2644 21.3705 16.9533C22.0015 16.6437 22.5644 16.2126 23.0264 15.6848C23.9598 14.6168 24.4761 13.2508 24.4812 11.8358C24.4904 10.9977 24.3319 10.1662 24.0149 9.38963ZM18.16 13.8166C18.0046 14.3261 17.7354 14.7942 17.3726 15.1858C17.231 15.3469 17.0565 15.4761 16.8607 15.5648C16.6649 15.6534 16.4523 15.6995 16.2371 15.6999C16.0702 15.7044 15.9047 15.6687 15.7546 15.5958C15.6046 15.523 15.4745 15.4152 15.3754 15.2816C15.1216 14.9013 15.001 14.4483 15.0323 13.993C15.0313 13.4286 15.1256 12.8681 15.3112 12.3348C15.4686 11.8531 15.7371 11.4147 16.0952 11.0546C16.2352 10.9075 16.4035 10.7901 16.5902 10.7093C16.7769 10.6284 16.978 10.5859 17.1817 10.5841C17.3621 10.5813 17.5409 10.618 17.7055 10.6917C17.8575 10.7662 17.99 10.8749 18.0924 11.0092C18.2071 11.1614 18.2925 11.3335 18.3442 11.5166C18.4064 11.7363 18.4366 11.9637 18.4338 12.192C18.4279 12.7444 18.3356 13.2925 18.16 13.8166Z"
                                fill="#265D91" />
                            <path
                                d="M29.7327 0.152588H5.26729C4.93122 0.15271 4.60895 0.285504 4.37132 0.521782C4.13368 0.758061 4.00012 1.07849 4 1.41264V25.7399C3.99989 25.9054 4.03259 26.0693 4.09624 26.2223C4.15989 26.3752 4.25323 26.5141 4.37094 26.6312C4.48864 26.7482 4.62839 26.841 4.78219 26.9043C4.936 26.9676 5.10085 27.0001 5.2673 27C5.321 26.9993 5.37462 26.9954 5.42784 26.9882L28.2728 24.0918C28.9654 24.0145 29.64 23.822 30.2684 23.5223C30.4868 23.4205 30.6716 23.259 30.8012 23.0567C30.9307 22.8544 30.9997 22.6196 31 22.3798V1.41264C30.9999 1.07849 30.8663 0.758055 30.6287 0.521775C30.3911 0.285496 30.0688 0.152704 29.7327 0.152588ZM28.4654 21.5045C28.3488 21.5351 28.2302 21.5581 28.1106 21.5734V21.5717L28.0329 21.5818C27.695 21.6208 27.3528 21.5769 27.0359 21.4541C25.9359 21.0207 25.3969 19.6985 25.3952 19.6934C25.2809 19.3967 25.0582 19.1538 24.7715 19.0133C24.4849 18.8728 24.1554 18.8451 23.8491 18.9357L6.53459 24.0515V2.67268H28.4654L28.4654 21.5045Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_555_428" x="0" y="0.152588" width="35" height="34.8474"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_555_428" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_555_428"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>
                    Contacter WEGESTU
                </h1>
                <!--begin::Menu-->
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Contacter WEGESTU</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card" [formGroup]="contactForm">
            <div class="card-body mt-15">
                <div class="container">
                    <div class="row mb-10">
                        <div class="col-lg-12">
                            <label for="objet">Type</label>
                            <select class="form-select mb-3" name="type" id="type" formControlName="type"
                                placeholder="Type" [ngClass]="{ 'is-invalid': submitted && f['type'].errors }">
                                <option [value]="item.id" *ngFor="let item of types">
                                    {{ item.value }}
                                </option>
                            </select>

                            <div *ngIf="submitted &&  f['type'].errors" class="invalid-feedback">
                                <div *ngIf="f['type'].errors['required']">Champ obligatoire</div>
                            </div>
                        </div>
                    </div>
                    <div class="mail mb-10">
                        <label for="objet">Objet</label>
                        <input type="text" name="objet" id="objet" placeholder="Objet" class="form-control mb-3"
                            formControlName="object" [ngClass]="{ 'is-invalid': submitted && f['object'].errors }">

                        <div *ngIf="submitted &&  f['object'].errors" class="invalid-feedback">
                            <div *ngIf="f['object'].errors['required']">Champ obligatoire</div>
                        </div>
                    </div>
                    <div class="sujet mb-10">
                        <label for="sujet">Sujet</label>
                   
                        
                        <quill-editor formControlName="subject"
                        style="width: 100%; height: 300px;"></quill-editor>
                        <div *ngIf="submitted &&  f['subject'].errors" class="invalid-feedback">
                            <div *ngIf="f['subject'].errors['required']">Champ obligatoire</div>
                        </div>
                    </div>
                    <div class="row mb-10">
                        <div class="col-lg-12">
                            <label for="file">Pièce jointe</label>
                            
                                <input  formControlName="cv" #inputFile type="file"  name="cv" id="cv"
                                class="form-control input-file mb-3"  (change)="onFileChange($event)" accept=".pdf, .docx, .psd, image/*">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4"></div>
                        <div class="col-lg-4 text-center">
                            <a class="send" (click)="contactWegestU()" style="cursor: pointer;">Envoyer</a>
                        </div>
                        <div class="col-lg-4"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
